import React from 'react';

export default class CommentWeblink extends React.Component {

	render() {

        const {weblink} = this.props;
        const backgroundImage = weblink.icon || weblink.image || '';

		return (
            <a href={weblink.url} target="_blank" rel="noopener noreferrer" className="tile">
                <div className="card">
                    <div className="card-media card-media--large" style={{backgroundImage: `url(${backgroundImage})`}}>
                    </div>
                    <div className="card-content card-content--inline">
                        {weblink.title}
                        <div className="meta" style={{marginTop: '0.25rem'}}>
                            <div>{weblink.url}</div>
                        </div>
                    </div>
                </div>
            </a>
        );
	}
};


// WEBPACK FOOTER //
// ./src/components/comment/CommentWeblink.js